function findNextUpcomingDate(arrayOfObjects, dateProperty) {
  // Return null if no dates are present
  if (!arrayOfObjects || arrayOfObjects.length === 0) {
    return null;
  }

  // Filter future dates and sort them
  const upcomingDates = arrayOfObjects
    .filter((obj) => {
      const objDateTime = new Date(obj[dateProperty]);
      return objDateTime > new Date();
    })
    .sort((a, b) => {
      const dateTimeA = new Date(a[dateProperty]);
      const dateTimeB = new Date(b[dateProperty]);
      return dateTimeA - dateTimeB;
    });

  // Return the first (closest) upcoming date, or null if none found (all dates in the past)
  return upcomingDates.length > 0 ? upcomingDates[0][dateProperty] : null;
}

function convertMinutes(minutes) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}h${remainingMinutes > 0 ? ` ${remainingMinutes}m` : ''}`;
}

function scrollToElement(id) {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
}

function parseUrlParams(searchParams) {
  const data = {};

  for (const [key, value] of Object.entries(searchParams)) {
    if (key.includes('.')) {
      const [parentKey, childKey] = key.split('.');
      if (!data[parentKey]) {
        data[parentKey] = {};
      }
      data[parentKey][childKey] = parseValue(value);
    } else {
      data[key] = parseValue(value);
    }
  }

  return data;
}

function parseValue(value) {
  if (value === 'null') return null;
  if (value === 'undefined') return undefined;
  if (value === 'true') return true;
  if (value === 'false') return false;
  if (!isNaN(value) && value !== '') return Number(value);
  return value;
}

function generateOtp(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

  for (let i = 0; i < length; i++)
    result += characters.charAt(Math.floor(Math.random() * characters.length));

  return result;
}

const pluralizeCroatian = (count, singular, paucal, plural) => {
  const absCount = Math.abs(count);
  const lastDigit = absCount % 10;
  const lastTwoDigits = absCount % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return plural;
  }

  if (lastDigit === 1) {
    return singular;
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return paucal;
  }

  return plural;
};

function determineExpiresAt({ planType, modules, revolvingSubscription = true }) {
  if (planType === 'subscription') {
    // Direct subscriptions are valid for 1 year (monthly payments not allowed)
    return revolvingSubscription
      ? null
      : new Date(new Date().setFullYear(new Date().getFullYear() + 1));
  }

  // Minimum length is 30 days, extra 15 days per module
  const duration = 30 + (modules.length - 1) * 15;

  // Get next event
  const nextEvent = findNextUpcomingDate(modules, 'lectureStartDateTime');

  // Use nextEvent date if it exists, otherwise fall back to Date.now()
  const startDate = nextEvent ? new Date(nextEvent) : new Date();

  return new Date(startDate.getTime() + 1000 * 60 * 60 * 24 * duration);
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export {
  findNextUpcomingDate,
  convertMinutes,
  scrollToElement,
  parseUrlParams,
  parseValue,
  generateOtp,
  pluralizeCroatian,
  determineExpiresAt,
  urlBase64ToUint8Array,
};
